import { ArrowRight } from "lucide-react";

const PARTNER_URL = "https://myae.co.uk";

export const PartnerBanner = () => (
  <section data-testid="partner-banner-section" className="relative border-t border-slate-200 bg-surface">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6">
      <div className="flex flex-col items-center justify-center gap-3 text-center sm:flex-row sm:gap-4">
        <span className="text-xs font-medium uppercase tracking-[0.16em] text-slatey">Part of the OpenDegree ecosystem</span>
        <span className="hidden h-4 w-px bg-slate-300 sm:block" />
        <div className="flex items-center gap-2.5">
          <span className="flex items-baseline gap-0.5">
            <span className="font-display text-lg font-black tracking-tighter text-[#3B2CC4]">My</span>
            <span className="font-display text-lg font-black tracking-tighter text-[#6D5DF6]">AE</span>
          </span>
          <span className="text-sm text-slatey">AI-powered academic feedback for learners</span>
          <a
            href={PARTNER_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="partner-banner-link"
            className="group inline-flex items-center gap-1 text-sm font-semibold text-[#5B4BE0] hover:underline"
          >
            Visit MyAE
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
          </a>
        </div>
      </div>
    </div>
  </section>
);
